module.exports = __webpack_public_path__ + "static/img/banner-exam.5811934.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/toefl/banner-exam.png
// module id = mU10
// module chunks = 96